import ResetPassword from '../../components/passwordRecovery/ResetPassword';

import React from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { sendRecoveryEmail, setEmail } from '../../actions/passwordRecoveryActions';
import { trackConversion } from '../../utils/analytics/googleTagManager';
import PropTypes from 'prop-types';

class ResetPasswordContainer extends React.Component {

  componentDidMount() {
    trackConversion();
  }

  setEmailValue = (event) => {
    this.props.setEmail(event.target.value || '');
  }

  render() {
    return (
      <ResetPassword
        email={this.props.email}
        errorText={this.props.errorText}
        isResetFetching={this.props.isResetFetching}
        resetPassword={this.props.sendRecoveryEmail}
        setEmail={this.setEmailValue} />
    );
  }
}

ResetPasswordContainer.propTypes = {
  email: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  isResetFetching: PropTypes.bool.isRequired,
  sendRecoveryEmail: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    email: state.passwordRecovery.email,
    errorText: state.passwordRecovery.errorText,
    isResetFetching: state.passwordRecovery.isFetching
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      sendRecoveryEmail,
      setEmail
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer);
